import { Box, Icon } from '@jfs/ui-new'
import { FC } from 'react'

interface CloseFormProps {
  onClose?: () => void
}

const CloseForm: FC<CloseFormProps> = ({ onClose }: CloseFormProps) => {
  return (
    <Box onPress={onClose} alignSelf="flex-end" underlayColor="WHITE">
      <Icon id="CLOSE" size="FONT_SIZE_DOUBLE_LARGE" />
    </Box>
  )
}

export { CloseForm }
